import { createFileRoute, stripSearchParams, useNavigate } from '@tanstack/react-router'
import { useCallback } from 'react'

import { CostsPage } from '@/components/DataVault/CostsPage'
import {
  dataVaultSearchSchema,
  EMPTY_SEARCH,
  withoutDataVaultDefaults,
  type DataVaultSearch,
} from '@/components/DataVault/search'

/** Wiring only. The schema lives beside the page in `search.ts`. */
export const Route = createFileRoute('/_app/data-vault/costs')({
  validateSearch: dataVaultSearchSchema,
  // A link to this page carries no defaults: the clean URL is the default view.
  search: { middlewares: [stripSearchParams(EMPTY_SEARCH)] },
  component: CostsRoute,
})

function CostsRoute() {
  const search = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })
  const onSearchChange = useCallback(
    (next: Partial<DataVaultSearch>) =>
      void navigate({
        search: (current) => withoutDataVaultDefaults({ ...current, ...next }),
        replace: true,
      }),
    [navigate],
  )
  return <CostsPage search={search} onSearchChange={onSearchChange} />
}
